module.exports = __webpack_public_path__ + "img/poster.fb5931fb.png";